import { SVGProps } from "react"

interface FileStepIconIconProps extends SVGProps<SVGSVGElement> {
  isActive?: boolean
}

const FileStepIcon = (props: FileStepIconIconProps) => (
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      width="50"
      height="50"
      rx="25"
      fill={props.isActive ? "#2768A3" : "#ABB7C2"}
      fill-opacity={props.isActive ? "1" : "0.1"}
    />
    <path
      d="M30 26.4V29.4C30 33.4 28.4 35 24.4 35H20.6C16.6 35 15 33.4 15 29.4V25.6C15 21.6 16.6 20 20.6 20H23.6"
      stroke={props.isActive ? "white" : "#B5BFC9"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M30 26.4H26.8C24.4 26.4 23.6 25.6 23.6 23.2V20L30 26.4Z"
      stroke={props.isActive ? "white" : "#B5BFC9"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M24.6 15H28.6" stroke="#B5BFC9" stroke-linecap="round" stroke-linejoin="round" />
    <path
      d="M20 18C20 16.34 21.34 15 23 15H25.62"
      stroke={props.isActive ? "white" : "#B5BFC9"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M35 21V27.19C35 28.74 33.74 30 32.19 30"
      stroke={props.isActive ? "white" : "#B5BFC9"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M35 21H32C29.75 21 29 20.25 29 18V15L35 21Z"
      stroke={props.isActive ? "white" : "#B5BFC9"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default FileStepIcon
